import { render, staticRenderFns } from "./CampaignsPaymentsRenderer.vue?vue&type=template&id=4bfddb60"
import script from "./CampaignsPaymentsRenderer.vue?vue&type=script&lang=js"
export * from "./CampaignsPaymentsRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports